import type { FaireProductEntity } from "../../entity_types/product";

export const p_jsw72dh7nm: FaireProductEntity = {
  token: "p_jsw72dh7nm",
  type: "product",
  name: "Feline Felon",
  brandToken: "b_4ztdnlvzm9",
  brandName: "Eurographics Puzzles USA",
  imageUrl:
    "https://cdn.faire.com/fastly/3b89ba861d62be578ad6b7da58b078f49f3b0569ee714f9ed569ed03f1c22e90.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0e471caec3199db2b311f9f67a9d391e5f872aaeafa6a3fbbbb22b60de5d160d.jpeg",
    "https://cdn.faire.com/fastly/3011705c5d14da3f82b23a049eab1f3803a7f751b776bf9a4be02c111b61602a.jpeg",
  ],
  priceDollars: 12.47,
  description:
    "I Ate the Piece is a comical image of a very hefty cat caught in the act of eating a puzzle piece.   Artist Lucia Heffernan.  Puzzle measures 19.25 x 26.6 inches.",
  tags: [],
  msrpDollars: 24.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:42.817Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
